document.addEventListener('DOMContentLoaded', function () {
    const elements = {
        modal: document.querySelector('.engraving-modal-content'),
        closeButton: document.querySelector('.engraving-modal-close'),
        confirmButton: document.querySelector('.engraving_btn'),
        cancelButton: document.querySelector('.engraving_cancel'),
        addButton: document.querySelector('#engraving__add'),
        editButton: document.querySelector('.engravings__wrapper-btn'),
        engravingDisplay: document.querySelector('.engravings'),
        engravingContent: document.querySelector('.engravings__wrapper-content'),
        engravingSelectors: document.querySelector('.engraving__selectors'),
        iconSlider: document.querySelector('.icon-wrapper-slider'),
        engravingData: document.querySelector('#engraving-data'),
        engravingPrice: document.querySelector('#engraving_price')
    };

    const currentProductId = elements.engravingSelectors ?
        elements.engravingSelectors.getAttribute('data-product-id') : null;

    if (!elements.addButton || !elements.iconSlider || !elements.modal || !currentProductId) {
        return;
    }

    function getEngravings() {
        try {
            const stored = localStorage.getItem('product_engravings');
            return stored ? JSON.parse(stored) : [];
        } catch (error) {
            console.error('Error accessing localStorage:', error);
            return [];
        }
    }

    function saveEngravings(engravingsArray) {
        try {
            localStorage.setItem('product_engravings', JSON.stringify(engravingsArray));
        } catch (error) {
            console.error('Error writing to localStorage:', error);
        }
    }

    function getCurrentProductEngraving() {
        const engravings = getEngravings();
        return engravings.find(item => item.id === currentProductId) || null;
    }

    function updateEngravingDataInput(text) {
        if (elements.engravingData) {
            elements.engravingData.value = text || '';
        }
        if (elements.engravingPrice) {
            if (text && text.trim() !== '') {
                const priceValue = elements.engravingPrice.getAttribute('data-price');
                elements.engravingPrice.value = priceValue;
            } else {
                elements.engravingPrice.value = '';
            }
        }
    }

    function saveProductEngraving(text) {
        const uppercaseText = text.toUpperCase();

        const engravings = getEngravings();
        const existingIndex = engravings.findIndex(item => item.id === currentProductId);
        if (existingIndex >= 0) {
            engravings[existingIndex].engraving = uppercaseText;
        } else {
            engravings.push({
                engraving: uppercaseText,
                id: currentProductId
            });
        }

        saveEngravings(engravings);
        updateEngravingDataInput(uppercaseText);
    }

    function removeProductEngraving() {
        if (!currentProductId) return;
        const engravings = getEngravings();
        const filteredEngravings = engravings.filter(item => item.id !== currentProductId);
        saveEngravings(filteredEngravings);
        updateEngravingDataInput('');
    }

    function getSelectedEngraving() {
        const selectedOption = document.querySelector('.emoji-option.selected, .engraving-option.selected');
        if (selectedOption) {
            return selectedOption.getAttribute('data-value') || selectedOption.textContent.trim();
        }
        const engravingInput = document.querySelector('.engraving-input');
        if (engravingInput) {
            return engravingInput.value.trim();
        }
        const current = getCurrentProductEngraving();
        return current ? current.engraving : '';
    }

    function openModal() {
        elements.modal.classList.add('open');
        initializeSlider();
    }

    function closeModal() {
        elements.modal.classList.remove('open');
    }

    function initializeSlider() {
        if (!elements.iconSlider.classList.contains('slick-initialized') && window.jQuery) {
            try {
                $(elements.iconSlider).slick({
                    dots: true,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 1,
                    adaptiveHeight: true,
                    draggable: true,
                    swipe: true
                });
            } catch (error) {
                console.error('Error initializing slider:', error);
            }
        }
    }

    function updateEngravingDisplay() {
        const currentEngraving = getCurrentProductEngraving();
        if (currentEngraving && currentEngraving.engraving) {
            elements.engravingContent.textContent = currentEngraving.engraving;
            elements.engravingSelectors.classList.remove('active');
            elements.engravingDisplay.classList.add('active');
        } else {
            elements.engravingSelectors.classList.add('active');
            elements.engravingDisplay.classList.remove('active');
        }
    }

    elements.addButton.addEventListener('click', openModal);
    elements.editButton.addEventListener('click', openModal);
    elements.closeButton.addEventListener('click', closeModal);

    elements.confirmButton.addEventListener('click', function () {
        const engravingText = getSelectedEngraving();
        if (engravingText) {
            saveProductEngraving(engravingText);
        }
        closeModal();
        updateEngravingDisplay();
    });

    elements.cancelButton.addEventListener('click', function () {
        closeModal();
        updateEngravingDisplay();
    });

    elements.modal.addEventListener('click', function (event) {
        if (event.target === elements.modal) {
            closeModal();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closeModal();
            updateEngravingDisplay();
        }
    });
    updateEngravingDisplay();

    const icon_items = document.querySelectorAll(".icon-container .icon");
    const engraving_input = document.querySelector(".engraving_input");
    const engraving_label = document.querySelector(".engraving_label");
    const engraving_form = document.querySelector(".engraving");
    const engraving_form_msg = document.querySelector(".engraving__form-msg");
    const engraving_preview = document.querySelector(".engraving-preview");
    const engraving__form_reset = document.querySelector(".engraving__form-reset");
    const engraving__cancel = document.querySelector(".engraving_cancel");

    if (!currentProductId) {
        console.warn('Product ID not found, engravings may not work properly');
    }

    icon_items.forEach((icon) => {
        icon.addEventListener('click', () => {
            engraving_input.focus();
            engraving_input.value += icon.textContent;
            engraving_input.setAttribute('value', engraving_input.value.trim());
            engraving_input.dispatchEvent(new Event('input'));
        });
    });

    engraving_input.addEventListener("input", () => {
        engraving_input.setAttribute('value', engraving_input.value.trim());
        const charCount = getUnicodeCharacterCount(engraving_input.value.trim());
        if (charCount > 0) {
            engraving_input.classList.add("engraving_input-focus");
            engraving_label.classList.add("engraving_label-focus");
            engraving__form_reset.classList.add("active");
        } else {
            engraving_input.classList.remove("engraving_input-focus");
            engraving_label.classList.remove("engraving_label-focus");
            engraving__form_reset.classList.remove("active");
        }
        if (charCount > 10) {
            engraving_form_msg.classList.add("active");
        } else {
            engraving_form_msg.classList.remove("active");
        }
        if (charCount > 0 && charCount < 11) {
            saveProductEngraving(engraving_input.value.trim());
        }
        updateEngravingPreview(engraving_input.value.trim());
    });

    engraving__form_reset.addEventListener("click", () => {
        engraving_input.value = "";
        engraving_preview.innerHTML = "";
        engraving_input.setAttribute('value', "");
        engraving_input.focus();
        removeProductEngraving();
    });

    engraving__cancel.addEventListener("click", () => {
        engraving_input.value = "";
        engraving_preview.innerHTML = "";
        engraving_input.setAttribute('value', "");
        engraving_input.focus();
        removeProductEngraving();
    });

    engraving_form.addEventListener("submit", (e) => {
        e.preventDefault();
        const charCount = getUnicodeCharacterCount(engraving_input.value.trim());
        if (charCount > 0) {
            saveProductEngraving(engraving_input.value.trim());
        }
    });

    function getUnicodeCharacterCount(str) {
        return [...str].length;
    }

    function updateEngravingPreview(inputValue) {
        const text = inputValue;
        const charCount = [...text].length;
        if (charCount === 0) {
            engraving_preview.innerHTML = '';
            return;
        }
        const formattedText = [...text].map(char => {
            return `<span class="engraving-char">${char}</span>`;
        }).join('');
        engraving_preview.innerHTML = formattedText;
        const baseFontSize = 40;
        const minFontSize = 10;
        let fontSize;
        if (charCount === 1) {
            fontSize = baseFontSize;
            engraving_preview.style.top = "50%";
        } else if (charCount > 6) {
            fontSize = Math.max(baseFontSize / (3.4 + 0.2 * Math.log(charCount)), minFontSize);
            engraving_preview.style.top = "55%";
        } else {
            fontSize = Math.max(baseFontSize / (1.8 + 0.2 * Math.log(charCount)), minFontSize);
            engraving_preview.style.top = "54%";
        }
        engraving_preview.style.fontSize = `${fontSize}px`;
        const letterSpacing = charCount > 5 ? "0px" : charCount > 3 ? "0.5px" : "1px";
        engraving_preview.style.letterSpacing = letterSpacing;
    }

    const currentEngraving = getCurrentProductEngraving();
    if (currentEngraving && currentEngraving.engraving) {
        engraving_input.value = currentEngraving.engraving;
        engraving_input.setAttribute('value', currentEngraving.engraving);
        engraving_input.classList.add("engraving_input-focus");
        engraving_label.classList.add("engraving_label-focus");
        engraving__form_reset.classList.add("active");
        updateEngravingPreview(currentEngraving.engraving);
    }

    if (elements.engravingData) {
        const currentEngraving = getCurrentProductEngraving();
        if (currentEngraving && currentEngraving.engraving) {
            elements.engravingData.value = currentEngraving.engraving;
            if (elements.engravingPrice) {
                const priceValue = elements.engravingPrice.getAttribute('data-price');
                elements.engravingPrice.value = priceValue;
            }
        } else if (elements.engravingPrice) {
            elements.engravingPrice.value = '';
        }
    }
});

function initStoreEngraving() {
    const engravingContent = document.querySelector('.engraving-content');
    if (!engravingContent) return;
    function isStoreSelected() {
        const storeInfo = document.querySelector('.js-my-store-locator-info');
        return storeInfo && storeInfo.textContent?.trim().length > 0;
    }

    function getSelectedStoreName() {
        const storeInfo = document.querySelector('.js-my-store-locator-info');
        return storeInfo ? storeInfo.textContent?.trim() : '';
    }

    function getAllowedStores() {
        try {
            const data = engravingContent.getAttribute('data-selected-locations');
            if (!data) return [];
            const stores = JSON.parse(data);
            return stores.map(store => store.location);
        } catch (error) {
            console.error('Error reading allowed stores:', error);
            return [];
        }
    }

    function isStoreAllowed() {
        const selectedStoreName = getSelectedStoreName();
        const allowedStores = getAllowedStores();

        if (allowedStores.length === 0) {
            return isStoreSelected();
        }

        const selectedStoreCode = getStoreCodeByName(selectedStoreName);

        return allowedStores.includes(selectedStoreCode);
    }

    function getStoreCodeByName(storeName) {
        if (!storeName || !window.locations) return null;

        for (const [code, displayName] of Object.entries(window.locations)) {
            if (displayName === storeName) {
                return code;
            }
        }
        return null;
    }

    function updateEngravingVisibility() {
        if (isStoreSelected() && isStoreAllowed()) {
            engravingContent.style.display = 'block';
        } else {
            engravingContent.style.display = 'none';
        }
    }

    function watchStoreChanges() {
        const storeInfo = document.querySelector('.js-my-store-locator-info');
        const storeContainer = document.getElementById('myLocationResults') || document.body;
        if (storeInfo) {
            const observer = new MutationObserver(() => {
                updateEngravingVisibility();
            });
            observer.observe(storeInfo, {
                childList: true,
                characterData: true,
                subtree: true
            });
            observer.observe(storeContainer, {
                childList: true,
                subtree: true
            });
        }
    }
    updateEngravingVisibility();
    watchStoreChanges();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoreEngraving);
} else {
    initStoreEngraving();
}
